import React,{useContext} from 'react';
import styled from 'styled-components';
import { FiCast,FiVideo,FiVideoOff,FiMic,FiMicOff,FiEdit } from "react-icons/fi";
import {ConfigContext} from '../Context/ConfigContext';


const CallController = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CallControllerButton = styled.button`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: transparent;
    border:  ${(props) => "2px solid "+props.theme.colors.white};
    color: ${(props) => props.theme.colors.white};
    font-weight: ${(props) => props.theme.font.weight.medium};
    outline: none;
    cursor: pointer;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
`;


const CallControllerComponent = ({handleChatInputToogle,chatInputToggle,displayStream}) => {
    const {state,setter} = useContext(ConfigContext);
    const {isAudio,isVideo} = state;
    const {setIsAudio,setIsVideo} = setter;
    return (
        <CallController>
            <CallControllerButton onClick={displayStream}>
                <FiCast/>
            </CallControllerButton>
            <CallControllerButton onClick={() => setIsAudio(!isAudio)}>
                {isAudio ? <FiMic/> : <FiMicOff/>}
            </CallControllerButton>
            <CallControllerButton onClick={() => setIsVideo(!isVideo)}>
                {isVideo ? <FiVideo/> : <FiVideoOff/>}
            </CallControllerButton>
            <CallControllerButton onClick={() => !chatInputToggle && handleChatInputToogle()}>
                <FiEdit/>
            </CallControllerButton>
        </CallController>
    )
}

export default CallControllerComponent;